import { render, staticRenderFns } from "./WorkBookBusinessAttributes.vue?vue&type=template&id=bda7bd50&scoped=true&"
import script from "./WorkBookBusinessAttributes.vue?vue&type=script&lang=js&"
export * from "./WorkBookBusinessAttributes.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookBusinessAttributes.vue?vue&type=style&index=0&id=bda7bd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7bd50",
  null
  
)

export default component.exports